import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthCard from "./AuthCard";
import { Button, Input } from "../../components/ui";
import { authService } from "../../services/auth";

export default function Forgot() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await authService.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard title="ลืมรหัสผ่าน" subtitle="กรอกอีเมลเพื่อรับลิงก์ตั้งรหัสผ่านใหม่" footer={<Link to="/login">กลับไปเข้าสู่ระบบ</Link>}>
      {sent ? (
        <div className="card card--grad center" role="status">
          <div className="strong">ส่งลิงก์แล้ว</div>
          <p className="muted mt-8">ตรวจสอบกล่องจดหมาย (รวมถึงสแปม) ของ {email}</p>
        </div>
      ) : (
        <form onSubmit={submit} noValidate>
          <Input label="อีเมล" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" error={error} autoComplete="email" />
          <Button type="submit" variant="primary" block size="lg" disabled={loading || !email}>{loading ? "กำลังส่ง..." : "ส่งลิงก์"}</Button>
        </form>
      )}
    </AuthCard>
  );
}
